import { __extends } from "tslib";
import * as React from 'react';
import { PreviewMode } from '../preview-elements/preview-context';
import { Text, Box, TextButton } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
var DescriptionPreviewWrapper = /** @class */ (function (_super) {
    __extends(DescriptionPreviewWrapper, _super);
    function DescriptionPreviewWrapper(props) {
        return _super.call(this, props) || this;
    }
    DescriptionPreviewWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(PreviewMode.Consumer, null, function (value) {
            return value.isPreview && !_this.props.description ? (React.createElement(Box, { direction: "vertical", marginBottom: 3 },
                React.createElement(Text, { weight: "thin", dataHook: "solution-description" },
                    React.createElement(TranslatedKey, { tkey: 'solution.page.preview.overviewText' })),
                React.createElement(TextButton, { as: "a", href: "https://dev.wix.com/dc3/my-apps/" + value.appId + "/market/info/basic-info", target: "_blank" },
                    React.createElement(TranslatedKey, { tkey: 'solution.page.preview.overview.cta' })))) : (_this.props.children);
        }));
    };
    return DescriptionPreviewWrapper;
}(React.Component));
export { DescriptionPreviewWrapper };
var TranslatedKey = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, tkey = _a.tkey;
    return t(tkey);
});
//# sourceMappingURL=description-wrapper.js.map